(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-compatible-models"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-compatible-models')) {
    customElements.define('product-compatible-models', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        if (this.initialized) return;
        const button = this.querySelector('.compatible-models__toggle');
        if (!button) return;
        this.initialized = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          this.querySelectorAll('[data-compatible-overflow]').forEach((item) => { item.hidden = !expanded; });
          button.querySelector('[data-compatible-expand]').hidden = expanded;
          button.querySelector('[data-compatible-collapse]').hidden = !expanded;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-compatible-models"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-compatible-models')) {
    customElements.define('variant-compatible-models', class extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.js-product');
        this.onVariantChange = (event) => {
          if (event.target.closest('.js-product') !== this.productSection) return;
          this.refresh(event.detail.variant?.id);
        };
        this.productSection?.addEventListener('on:variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        this.productSection?.removeEventListener('on:variant:change', this.onVariantChange);
        this.request?.abort();
      }

      async refresh(variantId) {
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        // Never show a previous variant's compatibility while loading or on failure.
        this.hidden = true;
        if (!variantId) return;
        const url = new URL(this.dataset.productUrl, window.location.origin);
        url.search = window.location.search;
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('variant', variantId);
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Compatible models section request failed');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const updated = document.getElementById(this.id);
          if (!updated || request.signal.aborted || !this.isConnected) return;
          // DOMParser parses noscript with scripting disabled. Moving its style
          // nodes into the live page would force all collapsed groups to display.
          updated.querySelectorAll('noscript').forEach((fallback) => fallback.remove());
          this.replaceChildren(...Array.from(updated.childNodes));
          this.hidden = false;
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Unable to refresh compatible models.', error);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
